import { combineReducers } from 'redux'
import merge from 'lodash/merge'
import { RECEIVE_CUSTOMERS, RECEIVE_CUSTOMER } from '../actions/customer-actions'
import { RESET_STORE } from '../actions/currentUser-actions'

const searchResults = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_CUSTOMERS:
      return merge([], action.customers, { query: action.query })
    case RESET_STORE:
      return []
    default:
      return state
  }
}

const detail = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_CUSTOMER:
      return { ...state, customer: action.customer }
    case RESET_STORE:
      return {}
    default:
      return state
  }
}

export default combineReducers({
  searchResults,
  detail,
})
